import React from "react";
import { isValidIpv4 } from "../../../services/organizationLoginIpService";
import "./Ipv4TextInput.scss";

export const sanitizeIpv4Text = (value) =>
  String(value || "")
    .replace(/[^\d.]/g, "")
    .slice(0, 15);

const Ipv4TextInput = ({
  value = "",
  onChange,
  onBlur,
  disabled = false,
  invalid = false,
  placeholder = "0.0.0.0",
  className = "",
  inputClassName = "form-control form-control-sm",
}) => {
  const showInvalid = invalid || (String(value || "").trim() !== "" && !isValidIpv4(value));

  return (
    <input
      type="text"
      inputMode="decimal"
      autoComplete="off"
      className={`ipv4-text-input ${inputClassName} ${showInvalid ? "is-invalid" : ""} ${className}`.trim()}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange?.(sanitizeIpv4Text(event.target.value))}
      onBlur={onBlur}
      aria-invalid={showInvalid}
    />
  );
};

export default Ipv4TextInput;
